import { render, staticRenderFns } from "./organization-requests.vue?vue&type=template&id=006766ec&"
import script from "./organization-requests.vue?vue&type=script&lang=js&"
export * from "./organization-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports